import * as ActionTypes from '../actions/index';
import {fromJS} from "immutable";
import {createReducer} from "./index";

const INITIAL_STATE = fromJS({
  fetching: false,
  specialOffers: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  orderBy: 0,
  order: 'desc',
  errorMessage: undefined,
  tempImage: undefined,
  changedSpecialOffer: undefined,
});

function getSpecialOffers(state, action) {
  return state.set('fetching', true);
}

function getSpecialOffersSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('specialOffers', fromJS(action.payload.body))
}

function getSpecialOffersFailed(state, action) {
  return state.set('fetching', false);
}

function countSpecialOffers(state, action) {
  return state;
}

function countSpecialOffersSuccess(state, action) {
  return state
    .set('total', action.payload.body.count)
}

function countSpecialOffersFailed(state, action) {
  return state;
}

function storeTemporarySpecialOfferImage(state, action) {
  return state.set('tempImage', action.payload)
}

function createSpecialOffer(state, action) {
  return state;
}

function createSpecialOffersSuccess(state, action) {
  return state
    .set('tempImage', undefined)
}

function createSpecialOfferFailed(state, action) {
  return state;
}

function clearSpecialOfferTempImage(state, action) {
  return state.set('tempImage', undefined)
}

function changeSpecialOfferPreferences(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function changeSpecialOffersOrder(state, action) {
  return state
    .set('order', action.payload.order)
    .set('orderBy', action.payload.orderBy)
}

function storeTemporaryProductSpecialOfferImage(state, action) {
  return state.set('tempImage', action.payload);
}

function editSpecialOffer(state, action) {
  return state;
}

function editSpecialOfferFailed(state, action) {
  return state;
}

function copySpecialOfferForEdit(state, action) {
  const specialOfferId = action.payload;
  const specialOffer = state
    .get('specialOffers').valueSeq().toArray()
    .filter(SpecialOfferImmutable =>
      String(SpecialOfferImmutable.get('id')) === String(specialOfferId))[0];
  return state.set('changedSpecialOffer', specialOffer );
}

function editSpecialOfferField(state, action) {
  return state
    .setIn(['changedSpecialOffer', action.payload.field], action.payload.value);
}

function deleteSpecialOfferFailed(state, action) {
  let errorMessage = null;
  try {
    errorMessage = action.payload.response.body.error.message
  } catch (e) {
    errorMessage = 'Failed to delete the special offer'
  }

  return state
    .set('errorMessage', errorMessage)
}

function clearProductSpecialOfferDeleteErrorMessage(state, action) {
  return state.set('errorMessage', undefined);
}

export const specialOffers = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_SPECIAL_OFFERS]: getSpecialOffers,
  [ActionTypes.GET_SPECIAL_OFFERS_SUCCESS]: getSpecialOffersSuccess,
  [ActionTypes.GET_SPECIAL_OFFERS_FAILED]: getSpecialOffersFailed,
  [ActionTypes.COUNT_SPECIAL_OFFERS]: countSpecialOffers,
  [ActionTypes.COUNT_SPECIAL_OFFERS_SUCCESS]: countSpecialOffersSuccess,
  [ActionTypes.COUNT_SPECIAL_OFFERS_FAILED]: countSpecialOffersFailed,
  [ActionTypes.CREATE_BRAND]: createSpecialOffer,
  [ActionTypes.CREATE_BRAND_SUCCESS]: createSpecialOffersSuccess,
  [ActionTypes.CREATE_BRAND_FAILED]: createSpecialOfferFailed,
  [ActionTypes.STORE_TEMPORARY_BRAND_IMAGE]: storeTemporarySpecialOfferImage,
  [ActionTypes.CHANGE_SPECIAL_OFFERS_PREFERENCES]: changeSpecialOfferPreferences,
  [ActionTypes.CHANGE_SPECIAL_OFFERS_ORDER]: changeSpecialOffersOrder,
  [ActionTypes.CLEAR_SPECIAL_OFFERS_FORM]: clearSpecialOfferTempImage,
  [ActionTypes.STORE_TEMPORARY_SPECIAL_OFFER_IMAGE]: storeTemporaryProductSpecialOfferImage,
  [ActionTypes.EDIT_SPECIAL_OFFER]: editSpecialOffer,
  [ActionTypes.EDIT_SPECIAL_OFFER_FAILED]: editSpecialOfferFailed,
  [ActionTypes.COPY_SPECIAL_OFFER_FOR_EDIT]: copySpecialOfferForEdit,
  [ActionTypes.EDIT_SPECIAL_OFFER_FIELD]: editSpecialOfferField,
  [ActionTypes.CLEAR_TEMP_UPLOADED_SPECIAL_OFFER]: clearSpecialOfferTempImage,
  [ActionTypes.DELETE_SPECIAL_OFFER_FAILED]: deleteSpecialOfferFailed,
  [ActionTypes.CLEAR_SPECIAL_OFFER_DELETE_ERROR_MESSAGE]: clearProductSpecialOfferDeleteErrorMessage,
});



// WEBPACK FOOTER //
// ./src/reducers/specialOffers.js